import {call, put, select} from "redux-saga/effects";
import {threadsSearchFilters} from "features/pages/threads/search/selectors";
import * as api from "services/api";
import {getErrorFromMessage} from "services/utils/utils";
import {threadsArchiveCurrentPage} from "features/pages/threads/archive/selectors";
import {errorThreadsSearchArchive, successThreadsSearchArchive} from "features/pages/threads/archive/reducer";

export function* getArchiveThreadsSaga() {
    const filters = yield select(threadsSearchFilters);
    const page = yield select(threadsArchiveCurrentPage);
    try {
        const data = yield call([api, api.searchArchivedThreadsApi], filters, page);
        yield put(successThreadsSearchArchive(data));
    } catch (e) {
        console.log(e);
        yield put(errorThreadsSearchArchive(getErrorFromMessage(e)));
    }
}